module.exports = __webpack_public_path__ + "img/logo-black-header.bdba221f.svg";